import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "site-footer",
  class: "bg-custom-secondary padding_top"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer_panel padding_bottom_half bottom20" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "/",
      class: "footer_logo bottom25"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: "/images/footer-logo.png",
        alt: "logo"
      })
    ])
  ])
], -1)
const _hoisted_5 = { class: "col-lg-3 col-md-6 col-sm-6" }
const _hoisted_6 = { class: "footer_panel padding_bottom_half bottom20" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "whitecolor bottom25" }, "Kontak Kami", -1)
const _hoisted_8 = { class: "whitecolor bottom25" }
const _hoisted_9 = { class: "d-table w-100 address-item whitecolor bottom25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "d-table-cell align-middle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile-alt" })
], -1)
const _hoisted_11 = { class: "d-table-cell align-middle bottom0" }
const _hoisted_12 = {
  class: "d-block",
  href: "mailto:web@support.com"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-6" }, null, -1)
const _hoisted_14 = { class: "col-lg-3 col-md-6 col-sm-6" }
const _hoisted_15 = { class: "footer_panel padding_bottom_half bottom20" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "whitecolor bottom25" }, "SOSIAL MEDIA KAMI", -1)
const _hoisted_17 = {
  class: "social-icons white wow fadeInUp",
  "data-wow-delay": "300ms"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-12\"><div style=\"background-color:#fff;padding:0.5px;\"></div></div></div><div class=\"row\"><div class=\"col-12 text-end\"><p class=\"whitecolor bottom25 text-end p-3\" style=\"float:right;\"> 2024© Pemerintah Provinsi DKI Jakarta </p></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.listInformation.address), 1),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.listInformation.phone) + " ", 1),
                _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.listInformation.email), 1)
              ])
            ])
          ])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("ul", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("a", {
                    href: item.url,
                    class: ""
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(item.icon)
                    }, null, 2)
                  ], 8, _hoisted_18)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _hoisted_19
    ])
  ]))
}